module.exports = __webpack_public_path__ + "img/12.31805fe3.jpg";